import { TranslocoHelper } from "@core/helpers/transloco.helper";
import { TableColumn, TableColumnTypeEnum } from "@oranta-mis/ui-library";


export const serviceOrderListColumnHeader= (i18n: TranslocoHelper): TableColumn[] =>[
  {
    type: TableColumnTypeEnum.text,
    key: 'service',
    name: i18n.tr('services'),
  },
  {
    type: TableColumnTypeEnum.actions,
    key: 'actions',
    name: i18n.tr('actions'),
    actions: ['details', 'pay', 'cancel'],
  },
];
